import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUrlAssets } from '../constants'
import { selectFields, setFieldValue, setFocusedField, selectFocusedField, selectBrands, setShowCvvHelp, useSelectFieldByName, useSelectFieldValueByName } from '../app/reducers/paymentMethod'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import PinField from "react-pin-field";
import Select from "react-dropdown-select";
import { useTranslation } from '../hooks/useTranslation';
import { selectMessagesI18n } from '../app/reducers/messagesI18n';
import { selectLanguage } from '../app/reducers/language';

export const TEXT_INPUT_FIELD = "text-field";
export const SELECT_FIELD = "select-field";
export const CARD_PREVIEW = "card-preview";
export const CARD_INPUT_FIELD = "card-field";
export const CARD_CVV_INPUT_FIELD = "card-cvv-field";
export const CARD_EXPIRATION_INPUT_FIELD = "card-expiration-field";
export const PHONE_INPUT_FIELD = "phone-field";
export const VERIFICATION_CODE_INPUT_FIELD = "verification-code-field";
export const MAIN_IMAGE_FIELD = "main-image-field";
export const PARAGRAPH_FIELD = "paragraph-field";
export const ICONS_BELT_FIELD = "icons-belt-field";
export const BIG_IMAGE_FIELD = "big-image-field";
export const CIP_CODE_FIELD = "cip-code-field";
export const BUTTON_BAR_FIELD = "button-bar-field";
export const TEXT_LIST_FIELD = "text-list-field";
export const DROPDOWN_INSTALLMENTS_FIELD = "dropdown-installments-field";

export default function Field({
  type,
  className = "",
  label,
  i18nKey,
  placeholder,
  value,
  name,
  id,
  attributes,
  options,
  onUpdateValue,
  url,
  weight,
  content,
  i18nContent,
  icons,
  random_key,
  show_when,
  list,
  size,
  original_content,
  prefix,
  hint,
  i18nHint
}) {
  const { t, tMixed } = useTranslation();
  const allFields = useSelector(selectFields);
  const messagesI18n = useSelector(selectMessagesI18n);
  const language = useSelector(selectLanguage);
  const focusedField = useSelector(selectFocusedField);
  const brands = useSelector(selectBrands);

  const renderWithIcons = (text) => {
    if (!text || typeof text !== 'string') return text;
    const parts = text.split(/(\[https?:\/\/[^\]]+\])/g);
    return parts.map((part, i) => {
      const urlMatch = part.match(/^\[(https?:\/\/[^\]]+)\]$/);
      if (urlMatch) return <img key={i} className="inline-icon" src={urlMatch[1]} alt="" />;
      return part;
    });
  };
  const field=useSelectFieldByName(name);
  const fieldValue=useSelectFieldValueByName(name);
  const dispatch = useDispatch();
  const pinCodeRef = useRef("");
  const pinContainerRef = useRef(null);
  const hasToShow = (fields) => fields.findIndex((f)=>{
    if("name" in f){
      if("value" in f){
        if(show_when!=null && show_when!=undefined){
          return f.name==show_when.field_name && f.value==show_when.value;
        }
      }
    }
    return false;
  })>=0;
  const getFieldValue = (fields, field_name)=>{
    let val="";
    let valFound=false;
    for(let k in fields){
      if(fields[k]["name"]==field_name && fields[k]["value"]!=undefined){
        val=String(fields[k]["value"]);
        valFound=true;
        break;
      }
    }
    if(val==""){
      valFound=false;
    }
    if(valFound){
      if(field_name=="field_expiration"){
        if(val.length>2){
          val=val.substring(0, 2) + "/" + val.substring(2);
        }
      }
    }else{
      if(field_name=="field_expiration"){
        val=t('payment_method.preview_card_expiration');
      }else if(field_name=="field_cardholder_name"){
        val=t('payment_method.preview_card_name');
      }else if(field_name=="field_cardholder_lastname"){
        val=t('payment_method.preview_card_lastname');
      }else if(field_name=="field_card"){
        val="0000000000000000";
      }
    }
    return val;
  };
  const getFieldMeta = (fields, field_name)=>{
    let meta={brand:"NA",installments:{list:[]}};
    for(let k in fields){
      if(fields[k]["name"]==field_name && fields[k]["meta"]!=undefined){
        meta=fields[k]["meta"];
        break;
      }
    }
    if(meta.brand==undefined){
      meta.brand="NA";
    }
    if(meta.installments==undefined){
      meta.installments={list:[]};
    }
    return meta;
  };
  const onChangeValue=(value)=>{
    if (type == DROPDOWN_INSTALLMENTS_FIELD) {
      let value_selected = "installments" in value ? value["installments"] : "0";
      dispatch(setFieldValue({name, value:value_selected, meta:value}));
      return;
    }
    if (attributes && "max_length" in attributes && value) {
      value = value.substr(0, attributes.max_length);
    }
    let withValue = (value != "" && value != null);
    if (withValue && type == CARD_EXPIRATION_INPUT_FIELD && value.length > 2) {
      value = value.replace("/", "");
    }
    dispatch(setFieldValue({name, value}));
  };
  let [hasFocus, setHasFocus] = useState(false);
  name = !name ? "field" : name;
  id = !id ? `${name}_${random_key}` : id;
  let getInputType = () => {
    switch (type) {
      case TEXT_INPUT_FIELD:
      case CARD_EXPIRATION_INPUT_FIELD:
      case CARD_CVV_INPUT_FIELD:
      case CARD_INPUT_FIELD:
        return "text";
      case PHONE_INPUT_FIELD:
      case VERIFICATION_CODE_INPUT_FIELD:
        return "number";
      default:
        return "text";
    }
  }
  let input_type = getInputType();
  let onFocus = (e) => {
    setHasFocus(true);
  }
  let onBlur = (e) => {
    setHasFocus(false);
  }
  const makeHasValue = () => {
    let value = fieldValue;
    return (value != "" && value != null);
  }
  const makeInputValue = () => {
    let value = fieldValue;
    if(!hasValue)
      return "";
    if (hasValue && type == CARD_EXPIRATION_INPUT_FIELD && value.length > 2) {
      value = value.replace("/", "");
      value = value.substr(0, 2) + "/" + value.substr(2, value.length);
    }
    if (hasValue && type == DROPDOWN_INSTALLMENTS_FIELD && value.length > 0) {
      let list = getFieldMeta(allFields,"field_card")["installments"]["list"];
      let element = list.find(f => f.installments==value);
      value = element!=undefined ? [element] : [];
    }
    return value;
  };
  const hasValue = makeHasValue();
  const inputValue = makeInputValue();
  const makeClassName = () => {
    let cn = "flex-input";
    cn += " flex-" + type;
    cn += className ? " " + className : "";
    cn += size ? " "+size : " md";
    cn += hasFocus ? " has-focus" : "";
    cn += hasValue ? " has-value" : "";
    if(field != undefined && "is_valid" in field){
      cn += field.is_valid ? " valid": " invalid";
    }if(field != undefined && "name" in field){
      cn += " " + field.name;
    }
    return cn;
  }
  const fieldClassName = makeClassName();
  const makeStyle = () => {
    let style={};
    if(weight) style['fontWeight']=weight;
    return style;
  }
  const removeSpaces = (val) => val.replaceAll(/\s/g, '');
  const groupInBlocksOfFour = (val) => val.replaceAll(/(.{4})/g, '$1 ').trim();
  const maskCardNumber = (val) => val.slice(0, 6) + '•'.repeat(val.length - 10) + val.slice(-4);
  const formatCardDisplay = (val) => {
    if (!val) return '';
    const digits = removeSpaces(val);
    const isPlaceholder = digits === '0000000000000000';
    const display = (!hasFocus && !isPlaceholder && digits.length > 10) ? maskCardNumber(digits) : digits;
    return groupInBlocksOfFour(display);
  };
  const handleCardChange = (e) => onChangeValue(removeSpaces(e.target.value).replace(/\D/g, ''));
  const maskAll = (val) => '•'.repeat(val.length);
  const formatCvvDisplay = (val) => {
    if (!val) return '';
    return hasFocus ? val : maskAll(val);
  };
  const installmentsContentRenderer = ({ props, state }) => (
    state.values.length>0 && <div className={"installment-wrap"} style={{ cursor: 'pointer' }}>
      <div className={"installment-element installment-label"}>{"i18nContent" in state.values[0] ? tMixed(state.values[0]["i18nContent"]) : state.values[0].label}</div>
      <div className={"installment-element installment-detail"}>
        {state.values[0].installments!="0" && <div className={"installment-description"+(state.values[0].interest?"":" installment-with-interest")}>{state.values[0].interest?t('installments.with_interest'):t('installments.without_interest')}</div>}
      </div>
    </div>
  );
  const installmentsItemRenderer = ({ item, methods }) => (
    <div className={"installment-item-wrap"} style={{ cursor: 'pointer' }} onClick={() => methods.addItem(item)}>
      <div className={"installment-element installment-label"}>{"i18nContent" in item ? tMixed(item["i18nContent"]) : item.label}</div>
      <div className={"installment-element installment-detail"}>
        {item.installments!="0" && <div className={"installment-description"+(item.interest?"":" installment-with-interest")}>{item.interest?t('installments.with_interest'):t('installments.without_interest')}</div>}
      </div>
    </div>
  );
  const isNameField = (fieldName) => ['field_cardholder_name', 'field_cardholder_lastname'].includes(fieldName);
  const sanitizeTextValue = (val) => isNameField(name) ? val.replaceAll(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛäëïöÄËÏÖçÇ\s]/g, '') : val;
  switch (type) {
    case SELECT_FIELD:
      return (
        <div className={fieldClassName}>
          {label && <label htmlFor={id}>{label}</label>}
          <select
            id={id} 
            value={inputValue}
            onChange={(e)=>onChangeValue(e.target.value)}>
            {options.map((data,pos)=>(<option key={pos} value={data.value}>{data.label}</option>))}
          </select>
        </div>
      );
    case CARD_INPUT_FIELD:
      return (
        <div className={fieldClassName}>
          {label && <label htmlFor={id}>{i18nKey ? t(i18nKey) : label}</label>}
          <input
            id={id} 
            type={input_type}
            inputMode="numeric"
            placeholder={placeholder}
            value={formatCardDisplay(inputValue)}
            onChange={handleCardChange}
            onFocus={onFocus}
            onBlur={onBlur} />
          <div className={"error-msg"}>{field.i18nKey_error_msg ? t(field.i18nKey_error_msg) : field.error}</div>
        </div>
      );
    case CARD_CVV_INPUT_FIELD:
      return (
        <div className={fieldClassName}>
          {label && <label htmlFor={id}>{i18nKey ? t(i18nKey) : label}</label>}
          <input
            id={id} 
            type={input_type}
            inputMode="numeric"
            placeholder={placeholder}
            value={formatCvvDisplay(inputValue)}
            onChange={(e)=>onChangeValue(e.target.value.replace(/\D/g, ''))}
            onFocus={(e) => { onFocus(e); dispatch(setFocusedField('field_cvv')); }}
            onBlur={(e) => { onBlur(e); dispatch(setFocusedField(null)); }} />
          <span className={"cvv-help-icon"} role="button" tabIndex={0} onClick={()=>dispatch(setShowCvvHelp(true))} onKeyDown={(e)=>{if(e.key==='Enter')dispatch(setShowCvvHelp(true))}}>
            <img src={getUrlAssets()+"/question-mark.svg"} className={"cvv-help-icon-circle"} alt="?" />
          </span>
          <div className={"error-msg"}>{field.i18nKey_error_msg ? t(field.i18nKey_error_msg) : field.error}</div>
        </div>
      );
    case CARD_EXPIRATION_INPUT_FIELD:
      return (
        <div className={fieldClassName}>
          {label && <label htmlFor={id}>{i18nKey ? t(i18nKey) : label}</label>}
          <input
            id={id} 
            type={input_type} 
            inputMode="numeric"
            placeholder={placeholder}
            value={inputValue}
            onChange={(e)=>onChangeValue(e.target.value.replace(/[^\d/]/g, ''))}
            onFocus={onFocus}
            onBlur={onBlur} />
          <div className={"error-msg"}>{field.i18nKey_error_msg ? t(field.i18nKey_error_msg) : field.error}</div>
        </div>
      );
    case TEXT_INPUT_FIELD:
      return (
        <div className={fieldClassName}>
          {label && <label htmlFor={id}>{i18nKey ? t(i18nKey) : label}</label>}
          <input
            id={id} 
            type={input_type} 
            placeholder={placeholder}
            value={inputValue}
            onChange={(e)=>onChangeValue(sanitizeTextValue(e.target.value))}
            onFocus={onFocus}
            onBlur={onBlur} />
          <div className={"error-msg"}>{field.i18nKey_error_msg ? t(field.i18nKey_error_msg) : field.error}</div>
        </div>
      );
    case DROPDOWN_INSTALLMENTS_FIELD:
      return (
        (getFieldMeta(allFields,"field_card")["installments"]["list"].length>0) &&
        <div className={fieldClassName}>
          {label && <label htmlFor={id}>{i18nKey ? t(i18nKey) : label}</label>}
          <Select
            values={inputValue}
            options={getFieldMeta(allFields,"field_card")["installments"]["list"]}
            labelField="label"
            valueField="installments"
            dropdownHeight="160px"
            contentRenderer={installmentsContentRenderer}
            itemRenderer={installmentsItemRenderer}
            onChange={(values) => onChangeValue(values[0])}
          />
        </div>
      );
    case PHONE_INPUT_FIELD: {
      const phonePrefix = attributes && attributes.phone_prefix ? attributes.phone_prefix : null;
      const isCurrentlyFocused = typeof document !== "undefined" && document.activeElement.id === id;
      const formatVisual = (val) => {
        if (!val) return "";
        const clean = val.replace(/\D/g, "");
        return clean.match(/.{1,3}/g)?.join(" ") || clean;
      };
      return (
        <div className={fieldClassName}>
          {label && <label htmlFor={id}>{prefix || ''}{i18nKey ? t(i18nKey) : label}</label>}
          <div className={phonePrefix ? "phone-input-wrapper" : ""}>
            {phonePrefix && <span className="phone-prefix">{phonePrefix}</span>}
            <input
              id={id} 
              type="text"
              inputMode="numeric"
              placeholder={placeholder}
              value={formatVisual(inputValue)}
              onChange={(e) => {
                const target = e.target;
                const currentVal = target.value;
                const cursorPosition = target.selectionStart;
                const digitsBeforeCursor = currentVal.slice(0, cursorPosition).replace(/\D/g, "").length;
                let rawVal = currentVal.replace(/\D/g, "");
                if (rawVal.length <= 9) {
                  onChangeValue(rawVal);
                  globalThis.requestAnimationFrame(() => {
                    const formatted = formatVisual(rawVal);
                    let newCursorPosition = 0;
                    if (digitsBeforeCursor > 0) {
                      let digitCount = 0;
                      for (let i = 0; i < formatted.length; i++) {
                        if (/\d/.test(formatted[i])) {
                          digitCount++;
                        }
                        if (digitCount === digitsBeforeCursor) {
                          newCursorPosition = i + 1;
                          break;
                        }
                      }
                    }
                    target.setSelectionRange(newCursorPosition, newCursorPosition);
                  });
                }
              }}
              onFocus={onFocus}
              onBlur={onBlur} />
          </div>
          {(hint || i18nHint) && <div className="hint-msg">{i18nHint ? renderWithIcons(tMixed(i18nHint)) : renderWithIcons(hint)}</div>}
          <div className={"error-msg"} style={{ visibility: (field.error && field.is_valid === false && !isCurrentlyFocused) ? 'visible' : 'hidden' }}>{field.i18nKey_error_msg ? t(field.i18nKey_error_msg) : (field.error || '\u00A0')}</div>
        </div>
      );
    }
    case VERIFICATION_CODE_INPUT_FIELD: {
      const markPinFieldsValidity = (isInvalid) => {
        if (pinContainerRef.current) {
          const inputs = pinContainerRef.current.querySelectorAll('.pin-field');
          inputs.forEach(input => {
            input.setCustomValidity(isInvalid ? 'incomplete' : '');
          });
        }
      };
      const handlePinChange = (code) => {
        pinCodeRef.current = code;
        markPinFieldsValidity(false);
      };
      const handlePinComplete = (code) => {
        pinCodeRef.current = code;
        markPinFieldsValidity(false);
        onChangeValue(code);
      };
      const handlePinBlur = (e) => {
        const container = e.currentTarget;
        setTimeout(() => {
          if (!container.contains(document.activeElement)) {
            if (pinCodeRef.current.length > 0 && pinCodeRef.current.length < 6) {
              onChangeValue(pinCodeRef.current);
              markPinFieldsValidity(true);
            }
          }
        }, 0);
      };
      return (
        <div className={`${fieldClassName} flex-verification-code-field`} role="group" onBlur={handlePinBlur}>
          {label && <label htmlFor={id}>{prefix || ''}{i18nKey ? t(i18nKey) : label}</label>}
          <div className="pin-field-container" ref={pinContainerRef}>
            <PinField 
              className="pin-field" 
              length={6} 
              validate="0123456789"
              onChange={handlePinChange}
              onComplete={handlePinComplete}
              inputMode="numeric"  />
          </div>
          {(hint || i18nHint) && <div className="hint-msg">{i18nHint ? renderWithIcons(tMixed(i18nHint)) : renderWithIcons(hint)}</div>}
        </div>
      );
    }
    case MAIN_IMAGE_FIELD:
      return (
        <div className={fieldClassName}>
          <img className={"logo"} src={url} />
        </div>
      );
    case BIG_IMAGE_FIELD:
      return (
        <div className={fieldClassName}>
          <img src={url} />
        </div>
      );
    case PARAGRAPH_FIELD:
      let resolvedMessage = null;
      let showOriginalLine = false;

      if (original_content && messagesI18n && messagesI18n.length > 0) {
        const msgEntry = messagesI18n.find(m => m.text === original_content);
        if (msgEntry) {
          const originalLang = msgEntry.lang;
          const translatedText = (msgEntry.translations || {})[language] || original_content;
          if (originalLang === language) {
            resolvedMessage = original_content;
          } else {
            resolvedMessage = translatedText;
            showOriginalLine = true;
          }
        }
      }

      // Extract the i18n label prefix (e.g. "i18n_payment.payment_decline_reason" from "i18n_payment.payment_decline_reason: Comercio requiere...")
      let labelOnly = null;
      if (i18nContent && resolvedMessage) {
        const colonIdx = i18nContent.indexOf(': ');
        if (colonIdx > -1) {
          labelOnly = i18nContent.substring(0, colonIdx + 2); // "i18n_payment.payment_decline_reason: "
        }
      }

      return (
        <div className={fieldClassName} style={makeStyle()}>
          {resolvedMessage && labelOnly
            ? <>{tMixed(labelOnly)}{resolvedMessage}</>
            : renderWithIcons(i18nContent ? tMixed(i18nContent) : content)
          }
          {showOriginalLine && (
            <div className="original-content">{original_content}</div>
          )}
        </div>
      );
    case ICONS_BELT_FIELD:
      return (
        <div className={fieldClassName} >
          {icons.map((value,pos) => <img key={pos} className={"icon-in-belt"} src={value} />)}
        </div>
      );
    case CIP_CODE_FIELD:
      return (
        <div className={fieldClassName}>
          <div className={"label"}>{i18nKey ? t(i18nKey) : label}</div>
          <div className={"value"}>{i18nContent ? tMixed(i18nContent) : content}<CopyToClipboard text={content}><img src={attributes.copy_icon} /></CopyToClipboard></div>
        </div>
      );
    case BUTTON_BAR_FIELD:
      return (
        <div className={fieldClassName}>
          {options.map((data,pos)=>(<div key={pos} className={"button "+(value==data.value?" selected":"")} onClick={()=>onChangeValue(data.value)}>{data.label}</div>))}
        </div>
      );
    case TEXT_LIST_FIELD:
      return (
        <div className={fieldClassName + (hasToShow(allFields)?" show":" hide")}>
          {list.map((data,pos)=>(<div key={pos}>{(pos+1)+"."} {data}</div>))}
        </div>
      );
    case CARD_PREVIEW:

      return (
        <>
        <div className={fieldClassName+" card-preview-brand-"+getFieldMeta(allFields,"field_card")["brand"]}>
          <div className={"card-preview-row right"}>
            {getFieldMeta(allFields,"field_card")["brand"] === "NA" ? (
              <div className={"card-preview-all-brands"}>
                {brands && brands.length > 0 ? (
                  brands.map(brand => <img key={brand} src={getUrlAssets()+"/card_brand_"+brand.toLowerCase()+(brand === "VISA" ? "_color" : "")+".svg"} alt={brand} />)
                ) : (
                  <>
                    <img src={getUrlAssets()+"/card_brand_visa_color.svg"} alt="Visa" />
                    <img src={getUrlAssets()+"/card_brand_mscd.svg"} alt="Mastercard" />
                    <img src={getUrlAssets()+"/card_brand_amex.svg"} alt="American Express" />
                    <img src={getUrlAssets()+"/card_brand_dinc.svg"} alt="Diners Club" />
                  </>
                )}
              </div>
            ) : (
              <div className={"card-preview-image-brand"}/>
            )}
          </div>
          <div className={"card-preview-row"}>
            <img src={getUrlAssets()+"/card_chip.svg"} />
          </div>
          <div className={"card-preview-row"}>
            <div className={"card-preview-card"}>{formatCardDisplay(getFieldValue(allFields,"field_card"))}</div>
          </div>
          <div className={"card-preview-row"}>
            <div className={"card-preview-name"}>{getFieldValue(allFields,"field_cardholder_name")+" "+getFieldValue(allFields,"field_cardholder_lastname")}</div>
            <div className={"card-preview-expiry-date"}>
              <span className={"card-preview-expiry-label"}>{t('payment_method.preview_card_expiry_line1')}<br/>{t('payment_method.preview_card_expiry_line2')}</span>
              <span>{getFieldValue(allFields,"field_expiration")}</span>
            </div>
          </div>
        </div>
        <div className={"payment-method-reminder"}>
          {focusedField === 'field_cvv'
            ? t('payment_method.cvv_input_hint')
            : t('payment_method.internet_purchase_reminder')}
        </div>
        </>
      );
    default:
      return (<p>{i18nKey ? t(i18nKey) : label}</p>);
  }
}
